function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var MainTemplate = require('./main.template');
var Menu = require('./menu');
var Composer = require('./composer');
var Profile = require('./profile');
var Create = require('./create');
var Sidebar = require('./sidebar');
var Main = /*#__PURE__*/function () {
  function Main(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '#saito-container';
    _classCallCheck(this, Main);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.composer = new Composer(app, mod);
    this.menu = new Menu(app, mod, '.sidebar-left', this.composer);
    this.manager = mod.manager;
    this.manager.container = '.manager';
    this.profile = new Profile(app, mod, '.sidebar-right > .redsquare-profile');
    this.mobile_profile = new Profile(app, mod, '.manager .redsquare-profile.mobile');
    this.create = new Create(app, mod, '.sidebar-right > .redsquare-create');
    this.sidebar = new Sidebar(app, mod, '.sidebar-right > .sidebar');
    this.active_mobile_view = 'feed';
    this.chat_manager = null;
    this.post_control_visible = true;
    this.post_visibility_observer = null;
    this.floating_post_resize_handler = null;
    this.visualViewport = null;
    this.visualViewportHandler = null;
  }
  return _createClass(Main, [{
    key: "setChatManager",
    value: function setChatManager() {
      var chatManager = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.chat_manager = chatManager;
      this.syncChatManagerContainer();
    }
  }, {
    key: "hasChatCapability",
    value: function hasChatCapability() {
      return Boolean(this.chat_manager && typeof this.chat_manager.render === 'function');
    }
  }, {
    key: "isCompactViewport",
    value: function isCompactViewport() {
      return typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 600px)').matches;
    }
  }, {
    key: "syncChatManagerContainer",
    value: function syncChatManagerContainer() {
      if (!this.hasChatCapability()) {
        return;
      }
      var compact = this.isCompactViewport();
      this.chat_manager.container = compact ? '.redsquare-mobile-chat' : '.sidebar-left';
      this.chat_manager.chat_popup_container = compact ? '.redsquare-mobile-chat' : '';
      this.chat_manager.render_manager_to_screen = 1;
    }
  }, {
    key: "showMobileView",
    value: function showMobileView() {
      var view = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'feed';
      if (!this.isCompactViewport()) {
        return false;
      }
      if (view === 'chat' && !this.hasChatCapability()) {
        view = 'feed';
      }
      document.querySelectorAll('.main > [data-mobile-view]').forEach(function (panel) {
        panel.hidden = panel.dataset.mobileView !== view;
      });
      this.active_mobile_view = view;
      document.body.dataset.redsquareMobileView = view;
      if (view === 'settings') {
        this.renderMobileSettings();
      }
      if (view === 'chat') {
        this.syncChatManagerContainer();
        this.chat_manager.render();
      }
      this.syncFloatingPostMenu();
      return true;
    }
  }, {
    key: "renderMobileSettings",
    value: function renderMobileSettings() {
      var _this$mod$settings_ov;
      var container = '.redsquare-mobile-settings';
      var host = document.querySelector(container);
      if (!host || host.querySelector('#redsquare-settings-overlay')) {
        return;
      }
      (_this$mod$settings_ov = this.mod.settings_overlay) === null || _this$mod$settings_ov === void 0 || _this$mod$settings_ov.renderInto(container);
    }
  }, {
    key: "render",
    value: function render() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (container) {
        this.container = container;
      }
      if (!document.querySelector(this.container)) {
        this.app.browser.addElementToDom(MainTemplate());
      } else {
        this.app.browser.replaceElementContentBySelector(MainTemplate(), this.container);
      }
      this.syncChatManagerContainer();
      this.menu.render();
      this.manager.render();
      var profileKey = this.manager.isProfileMode() ? this.manager.active_profile_key : this.mod.publicKey;
      this.profile.render('', profileKey);
      this.create.render();
      this.sidebar.render();
      if (this.isCompactViewport()) {
        this.showMobileView(this.active_mobile_view);
      }
      this.attachVisualViewportHandler();
      this.attachEvents();
    }
  }, {
    key: "attachVisualViewportHandler",
    value: function attachVisualViewportHandler() {
      var _this = this;
      var container = document.querySelector(this.container);
      if (!container || !window.visualViewport) {
        return;
      }
      this.removeVisualViewportHandler();
      this.visualViewport = window.visualViewport;
      this.visualViewportHandler = function () {
        var _document$querySelect;
        var headerBottom = Math.max(0, ((_document$querySelect = document.querySelector('#saito-header')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.getBoundingClientRect().bottom) || 0);
        var viewportTop = _this.visualViewport.offsetTop;
        var containerTop = Math.max(viewportTop, headerBottom);
        var visibleHeaderHeight = Math.max(0, headerBottom - viewportTop);
        container.style.setProperty('--redsquare-page-viewport-top', "".concat(containerTop, "px"));
        container.style.setProperty('--redsquare-page-viewport-height', "".concat(Math.max(0, _this.visualViewport.height - visibleHeaderHeight), "px"));
      };
      this.visualViewportHandler();
      this.visualViewport.addEventListener('resize', this.visualViewportHandler);
      this.visualViewport.addEventListener('scroll', this.visualViewportHandler);
    }
  }, {
    key: "removeVisualViewportHandler",
    value: function removeVisualViewportHandler() {
      if (this.visualViewport && this.visualViewportHandler) {
        this.visualViewport.removeEventListener('resize', this.visualViewportHandler);
        this.visualViewport.removeEventListener('scroll', this.visualViewportHandler);
      }
      this.visualViewport = null;
      this.visualViewportHandler = null;
    }
  }, {
    key: "attachSidebarScrollSync",
    value: function attachSidebarScrollSync() {
      var _this2 = this;
      var root = document.querySelector(this.container);
      var scroller = root === null || root === void 0 ? void 0 : root.querySelector('.manager .body');
      if (!scroller || scroller.dataset.sidebarScrollSyncBound === '1') {
        return;
      }
      scroller.dataset.sidebarScrollSyncBound = '1';
      var previousScrollTop = scroller.scrollTop;
      var frame = null;
      scroller.addEventListener('scroll', function () {
        if (frame !== null) {
          return;
        }
        frame = window.requestAnimationFrame(function () {
          frame = null;
          var currentScrollTop = scroller.scrollTop;
          var scrollDelta = currentScrollTop - previousScrollTop;
          previousScrollTop = currentScrollTop;
          if (scrollDelta === 0 || _this2.isCompactViewport()) {
            return;
          }
          root.querySelectorAll('.sidebar-left, .sidebar-right').forEach(function (sidebar) {
            if (sidebar.clientHeight > 0 && sidebar.scrollHeight > sidebar.clientHeight) {
              sidebar.scrollTop += scrollDelta;
            }
          });
        });
      }, {
        passive: true
      });
    }
  }, {
    key: "canConsumeWheel",
    value: function canConsumeWheel(target, root, scrollDelta) {
      var element = (target === null || target === void 0 ? void 0 : target.nodeType) === 1 ? target : target === null || target === void 0 ? void 0 : target.parentElement;
      while (element && element !== root) {
        var overflowY = window.getComputedStyle(element).overflowY;
        if ((overflowY === 'auto' || overflowY === 'scroll') && element.scrollHeight > element.clientHeight) {
          var maxScrollTop = element.scrollHeight - element.clientHeight;
          if (scrollDelta < 0 && element.scrollTop > 0 || scrollDelta > 0 && element.scrollTop < maxScrollTop) {
            return true;
          }
        }
        element = element.parentElement;
      }
      return false;
    }
  }, {
    key: "attachFeedWheelScroll",
    value: function attachFeedWheelScroll() {
      var _this3 = this;
      var root = document.querySelector(this.container);
      if (!root || root.dataset.feedWheelScrollBound === '1') {
        return;
      }
      root.dataset.feedWheelScrollBound = '1';
      root.addEventListener('wheel', function (event) {
        var scroller = root.querySelector('.manager .body');
        if (!scroller || event.defaultPrevented || event.ctrlKey || event.deltaY === 0 || _this3.isCompactViewport() || scroller.contains(event.target) || _this3.canConsumeWheel(event.target, root, event.deltaY)) {
          return;
        }
        var deltaScale = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? scroller.clientHeight : 1;
        var previousScrollTop = scroller.scrollTop;
        scroller.scrollTop += event.deltaY * deltaScale;
        if (scroller.scrollTop !== previousScrollTop) {
          event.preventDefault();
        }
      }, {
        passive: false
      });
    }
  }, {
    key: "positionFloatingPostMenu",
    value: function positionFloatingPostMenu() {
      var root = document.querySelector(this.container);
      var manager = root === null || root === void 0 ? void 0 : root.querySelector('.manager');
      var menu = document.querySelector('#saito-floating-menu');
      if (!manager || !menu) {
        return;
      }
      var bounds = manager.getBoundingClientRect();
      var rightInset = Math.max(0, window.innerWidth - bounds.right);
      var bottomInset = Math.max(0, window.innerHeight - bounds.bottom);
      menu.style.setProperty('--redsquare-feed-right-inset', "".concat(rightInset, "px"));
      menu.style.setProperty('--redsquare-feed-bottom-inset', "".concat(bottomInset, "px"));
    }
  }, {
    key: "syncFloatingPostMenu",
    value: function syncFloatingPostMenu() {
      var menu = document.querySelector('#saito-floating-menu');
      if (!menu) {
        return;
      }
      var feedActive = !this.isCompactViewport() || this.active_mobile_view === 'feed';
      var show = feedActive && !this.post_control_visible;
      menu.classList.toggle('redsquare-post-offscreen', show);
      if (show) {
        this.positionFloatingPostMenu();
      } else {
        menu.classList.remove('activated');
      }
    }
  }, {
    key: "attachFloatingPostVisibility",
    value: function attachFloatingPostVisibility() {
      var _this$post_visibility,
        _this4 = this;
      var root = document.querySelector(this.container);
      var postControl = root === null || root === void 0 ? void 0 : root.querySelector('.sidebar-right > .redsquare-create');
      var menu = document.querySelector('#saito-floating-menu');
      (_this$post_visibility = this.post_visibility_observer) === null || _this$post_visibility === void 0 || _this$post_visibility.disconnect();
      if (this.floating_post_resize_handler) {
        window.removeEventListener('resize', this.floating_post_resize_handler);
      }
      if (!postControl || !menu || typeof IntersectionObserver === 'undefined') {
        return;
      }
      this.post_visibility_observer = new IntersectionObserver(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 1),
          entry = _ref2[0];
        _this4.post_control_visible = entry.isIntersecting;
        _this4.syncFloatingPostMenu();
      });
      this.post_visibility_observer.observe(postControl);
      this.floating_post_resize_handler = function () {
        if (!_this4.post_control_visible) {
          _this4.positionFloatingPostMenu();
        }
      };
      window.addEventListener('resize', this.floating_post_resize_handler, {
        passive: true
      });
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      this.menu.attachEvents();
      this.manager.attachEvents();
      this.profile.attachEvents();
      this.create.attachEvents();
      this.sidebar.attachEvents();
      this.attachSidebarScrollSync();
      this.attachFeedWheelScroll();
      this.attachFloatingPostVisibility();
    }
  }, {
    key: "showProfile",
    value: function showProfile() {
      var publicKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.profile.render('', publicKey || this.mod.publicKey);
    }
  }, {
    key: "showMobileProfile",
    value: function showMobileProfile() {
      var publicKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (!document.querySelector(this.mobile_profile.container)) {
        return;
      }
      this.mobile_profile.render('', publicKey || this.mod.publicKey);
    }
  }]);
}();
module.exports = Main;